import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NAV_ITEMS, SECTION_IDS, IMAGES } from '../utils/constants';

const Header = () => {
    const { t } = useTranslation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
            setMobileMenuOpen(false);
        }
    };

    return (
        <header className="bg-white shadow-sm sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center">
                        <span className="text-2xl font-bold text-pastita-orange">
                          <img src={IMAGES.LOGO_BLACK} alt={t('common.appName')} className="h-8 sm:h-10"/>
                        </span>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-4 lg:space-x-8">
                        {NAV_ITEMS.map(item => (
                            <button 
                                key={item.id}
                                onClick={() => scrollToSection(item.id)}
                                className="text-gray-700 hover:text-pastita-orange transition-colors text-sm lg:text-base">
                                {t(`header.${item.id === 'how-it-works' ? 'howItWorks' : 
                                     item.id === 'where-we-are' ? 'whereWeAre' : 
                                     item.id === 'contact' ? 'contacts' : 
                                     item.id === 'subscription' ? 'subscriptions' : 'menu'}`)}
                            </button>
                        ))}
                    </nav>

                    {/* Desktop CTA Button */}
                    <button
                        onClick={() => scrollToSection(SECTION_IDS.SIMULATOR)}
                        className="hidden sm:block bg-pastita-orange text-white px-4 lg:px-6 py-2 rounded-lg hover:bg-orange-700 transition-colors font-medium text-sm lg:text-base">
                        {t('common.buttons.simulator')}
                    </button>

                    {/* Mobile Menu Button */}
                    <div className="flex md:hidden items-center space-x-4">
                        <button
                            onClick={() => scrollToSection(SECTION_IDS.SIMULATOR)}
                            className="sm:hidden bg-pastita-orange text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition-colors font-medium text-sm">
                            {t('common.buttons.simulator')}
                        </button>
                        <button
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            className="text-gray-700 hover:text-pastita-orange focus:outline-none"
                            aria-expanded={mobileMenuOpen}
                        >
                            <span className="sr-only">{t('header.openMenu')}</span>
                            {/* Hamburger icon */}
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                    strokeWidth={2} 
                                    d={mobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
                    <div className="px-2 pt-2 pb-3 space-y-1">
                        {NAV_ITEMS.map(item => (
                            <button
                                key={item.id}
                                onClick={() => scrollToSection(item.id)}
                                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-pastita-orange hover:bg-gray-50"
                            >
                                {t(`header.${item.id === 'how-it-works' ? 'howItWorks' : 
                                     item.id === 'where-we-are' ? 'whereWeAre' : 
                                     item.id === 'contact' ? 'contacts' : 
                                     item.id === 'subscription' ? 'subscriptions' : 'menu'}`)}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
